import { ActionType, createAction } from 'typesafe-actions';
import { Email } from '@rossum/api-client/email';
import { ID } from '../../../types/basic';

export const sendEmailFulfilled = createAction(
  'SEND_EMAIL_FULFILLED',
  (payload: Email) => payload
)<Email>();

export const updateEmail = createAction(
  'UPDATE_EMAIL',
  (email: Partial<Email>, _emailId: ID) => email,
  (_, id) => ({ id })
)<Partial<Email>, { id: ID }>();

export const updateEmailFulfilled = createAction(
  'UPDATE_EMAIL_FULFILLED',
  (payload: Email) => payload
)<Email>();

export const rejectEmail = createAction(
  'REJECT_EMAIL',
  (payload: { rootEmailId: number }) => payload
)<{ rootEmailId: number }>();

export type EmailActions = ActionType<
  | typeof sendEmailFulfilled
  | typeof updateEmail
  | typeof updateEmailFulfilled
  | typeof rejectEmail
>;
